import { render, staticRenderFns } from "./QuizPaginatorLine.vue?vue&type=template&id=6b2f2634&scoped=true&"
import script from "./QuizPaginatorLine.vue?vue&type=script&lang=js&"
export * from "./QuizPaginatorLine.vue?vue&type=script&lang=js&"
import style0 from "./QuizPaginatorLine.vue?vue&type=style&index=0&id=6b2f2634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2f2634",
  null
  
)

export default component.exports